import React from 'react';
import { Typography, Box, TextField, IconButton, Autocomplete, Chip } from '@mui/material';
import { Edit, Check, Close } from '@mui/icons-material';

const ProjectInfo = ({ 
  projectData, 
  editingField, 
  editValue, 
  editDates,
  companiesData,
  getCompanyNames,
  formatDate,
  onEditField, 
  onSaveField, 
  onCancelEdit,
  onEditValueChange,
  onEditDatesChange
}) => {
  return (
    <>
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          {editingField === 'customer' ? (
            <>
              <Typography variant="body1" sx={{ mr: 1, flexShrink: 0 }}>Customer:</Typography>
              <TextField
                value={editValue}
                onChange={(e) => onEditValueChange(e.target.value)}
                variant="standard"
                size="small"
                fullWidth
              />
              <IconButton onClick={onSaveField} color="success" size="small" sx={{ ml: 1 }}>
                <Check fontSize="small" />
              </IconButton>
              <IconButton onClick={onCancelEdit} color="error" size="small">
                <Close fontSize="small" />
              </IconButton>
            </>
          ) : (
            <>
              <Typography variant="body1">
                Customer: {projectData.customer && <strong>{projectData.customer}</strong>}
              </Typography>
              <IconButton onClick={() => onEditField('customer', projectData.customer)} size="small" sx={{ ml: 1 }}>
                <Edit fontSize="small" />
              </IconButton>
            </>
          )}
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          {editingField === 'conditions_of_acceptance' ? (
            <>
              <Typography variant="body1" sx={{ mr: 1, flexShrink: 0 }}>Conditions:</Typography>
              <TextField
                value={editValue}
                onChange={(e) => onEditValueChange(e.target.value)}
                variant="standard"
                size="small"
                fullWidth
              />
              <IconButton onClick={onSaveField} color="success" size="small" sx={{ ml: 1 }}>
                <Check fontSize="small" />
              </IconButton>
              <IconButton onClick={onCancelEdit} color="error" size="small">
                <Close fontSize="small" />
              </IconButton>
            </>
          ) : (
            <>
              <Typography variant="body1">
                Conditions: {projectData.conditions_of_acceptance && <strong>{projectData.conditions_of_acceptance}</strong>}
              </Typography>
              <IconButton onClick={() => onEditField('conditions_of_acceptance', projectData.conditions_of_acceptance)} size="small" sx={{ ml: 1 }}>
                <Edit fontSize="small" />
              </IconButton>
            </>
          )}
        </Box>
      </Box>
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          {editingField === 'company_ids' ? (
            <>
              <Typography variant="body1" sx={{ mr: 1, flexShrink: 0 }}>Companies:</Typography>
              <Autocomplete
                multiple
                options={companiesData?.companies?.list || []}
                getOptionLabel={(option) => option.name}
                value={(companiesData?.companies?.list || []).filter(c => editValue.includes(c.id))}
                onChange={(e, newValue) => onEditValueChange(newValue.map(c => c.id))}
                size="small"
                fullWidth
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip variant="outlined" label={option.name} {...getTagProps({ index })} key={option.id} size="small" />
                  ))
                }
                renderInput={(params) => <TextField {...params} variant="standard" />}
              />
              <IconButton onClick={onSaveField} color="success" size="small" sx={{ ml: 1 }}>
                <Check fontSize="small" />
              </IconButton>
              <IconButton onClick={onCancelEdit} color="error" size="small">
                <Close fontSize="small" />
              </IconButton>
            </>
          ) : (
            <>
              <Typography variant="body1">
                Companies: {getCompanyNames(projectData.company_ids) && <strong>{getCompanyNames(projectData.company_ids)}</strong>}
              </Typography>
              <IconButton onClick={() => onEditField('company_ids', projectData.company_ids)} size="small" sx={{ ml: 1 }}>
                <Edit fontSize="small" />
              </IconButton>
            </>
          )}
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {editingField === 'dates' ? (
            <>
              <Typography variant="body1" sx={{ mr: 1, flexShrink: 0 }}>Dates:</Typography>
              <TextField
                type="date"
                value={editDates.start}
                onChange={(e) => onEditDatesChange({ ...editDates, start: e.target.value })}
                variant="standard"
                size="small"
                sx={{ flex: 1 }}
              />
              <Typography sx={{ mx: 0.5, flexShrink: 0 }}>-</Typography>
              <TextField
                type="date"
                value={editDates.end}
                onChange={(e) => onEditDatesChange({ ...editDates, end: e.target.value })}
                variant="standard"
                size="small"
                sx={{ flex: 1 }}
              />
              <IconButton onClick={onSaveField} color="success" size="small" sx={{ ml: 1 }}>
                <Check fontSize="small" />
              </IconButton>
              <IconButton onClick={onCancelEdit} color="error" size="small">
                <Close fontSize="small" />
              </IconButton>
            </>
          ) : (
            <>
              <Typography variant="body1">
                Planned dates: {(projectData.planned_start_date || projectData.planned_end_date) && <strong>{formatDate(projectData.planned_start_date) || 'TBD'} - {formatDate(projectData.planned_end_date) || 'TBD'}</strong>}
              </Typography>
              <IconButton onClick={() => onEditField('dates')} size="small" sx={{ ml: 1 }}>
                <Edit fontSize="small" />
              </IconButton>
            </>
          )}
        </Box>
      </Box>
    </>
  );
};

export default ProjectInfo;
